import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';

import { ICON_TYPES } from '../../../shared/constants';

import { DEQ_COMPS, DEQ_TYPES } from '../../../utils/deq';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';

import InfoIcon from '../icons/InfoIcon';
import TooltipWindow from '../tooltip-window/TooltipWindow';

interface Props {
  className?: string;
  label: string;
  children: ReactNode;
  infoDirection?: string;
}

const InfoPopover = ({
  className,
  label,
  children,
  infoDirection = 'left',
}: Props) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <Container className={className}>
      {open && (
        <ClickOverlay
          onClick={() => {
            toggleOpen();
          }}
        />
      )}
      {open && (
        <TooltipWindow windowDirection={infoDirection} customClick={toggleOpen}>
          {children}
        </TooltipWindow>
      )}
      <InfoLink
        onClick={(e) => {
          e.preventDefault();
          toggleOpen();
        }}
        data-element-type={DEQ_TYPES.info}
        data-element-label={`${label}`.toLowerCase()}
        data-component-type={DEQ_COMPS.tooltip}
      >
        <InfoIcon
          className="end"
          color={Colors.abnGreen400}
          key={`icon-${ICON_TYPES.info}`}
          height="20px"
          width="20px"
        />
      </InfoLink>
    </Container>
  );
};

export default InfoPopover;

const Container = styled.div`
  height: fit-content;
  position: relative;
`;

const ClickOverlay = styled.div`
  background-color: transparent;
  bottom: 0;
  box-sizing: border-box;
  height: 100vh;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 0;
`;

const InfoLink = styled.button`
  background: none;
  border: none;
  padding: 0;

  ${mq.from.breakpoint.L`
    &:hover {
      cursor: pointer;

      & > svg > * {
        fill: ${Colors.abnGreen400};
      }
    }
  `}

  &:active {
    & > svg > * {
      fill: ${Colors.abnGreen400};
    }
  }
`;
